import { useMemo, useEffect } from "react";
import Fuse from "fuse.js";

const Search = ({ query, setQuery, range, setProduct }) => {
  const options = {
    keys: ["id", "name"],
    threshold: 0.1,
  };

  // Ensure Fuse updates options as stencils are added/removed
  const fuse = useMemo(() => {
    const validRange = Array.isArray(range) ? range : [];
    return new Fuse(validRange, options);
  }, [range]);

  const filterSearch = (phrase) => {
    // query is blank
    if (!phrase || phrase.trim() === "") {
      setProduct(range);
      return;
    }

    const results = fuse.search(phrase);
    const filtered = results.map((result) => result.item);
    setProduct(filtered);
  };

  useEffect(() => {
    filterSearch(query);
  }, [range]);

  return (
    <div style={{ display: "inline" }}>
      <input
        type="search"
        placeholder="Search by Stencil ID or Name..."
        value={query}
        onChange={(e) => {
          const value = e.target.value;
          setQuery(value);
          filterSearch(value);
        }}
        style={{
          textAlign: "left",
          "&::placeholder": {
            fontStyle: "italic",
          },
        }}
      />
    </div>
  );
};

export default Search;
